import { Stack } from '@drycut/ui-components';
import { twJoin } from 'tailwind-merge';

import StepIndicator from './StepIndicator';

export type CheckoutStepProps = {
  children: React.ReactNode;
  disabled?: boolean;
  headerHidden?: boolean;
  number: null | number;
  title: React.ReactNode;
};

export function CheckoutStep({
  number,
  title,
  disabled = false,
  headerHidden = false,
  children,
}: CheckoutStepProps): React.ReactElement {
  return (
    <Stack className={twJoin('lg:flex-1 w-full relative', disabled && 'cursor-not-allowed')}>
      <Stack
        gap={4}
        as="fieldset"
        className={twJoin('', disabled && 'pointer-events-none opacity-30')}
        disabled={disabled}
      >
        {!headerHidden && <StepIndicator number={number}>{title}</StepIndicator>}
        {children}
      </Stack>
    </Stack>
  );
}
